const SORT = {
    ORDER: [
        {
            value: 'updatedAt',
            label: 'Last Modified',
        },
        {
            value: {
                all: 'title',
                chart: 'title',
                currency: 'title',
                mapspice: 'title',
                layout: 'title',
                survey: 'title',
            },
            label: 'Title',
        }
    ],
    DIRECTION: [
        {
            value: 'asc',
            label: 'Ascending',
        },
        {
            value: 'desc',
            label: 'Descending',
        },
    ],
};

export default SORT;


// WEBPACK FOOTER //
// ./src/enums/Sort.js